export default __webpack_public_path__ + "static/media/2930 spice rack A top.52b9438e.png";